import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, KeyRound } from 'lucide-react';
import AppIcon from '../components/AppIcon';
import { getErrorMessage } from '../api/errors';
import { authService } from '../services';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const result = await authService.forgotPassword({ email });
      setMessage(result.message);
      setEmail('');
    } catch (err) {
      setError(getErrorMessage(err, 'İşlem tamamlanamadı.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <span className="auth-icon">
            <AppIcon icon={KeyRound} size={40} />
          </span>
          <h1>Şifremi Unuttum</h1>
          <p>Kayıtlı e-posta adresinize şifre sıfırlama bağlantısı gönderilir.</p>
        </div>

        {error && <div className="auth-error">{error}</div>}
        {message && <div className="auth-success">{message}</div>}

        {!message && (
          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">E-posta</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ornek@email.com"
                required
                autoComplete="email"
              />
            </div>

            <button type="submit" className="btn btn-primary btn-lg btn-block" disabled={loading}>
              {loading ? 'Gönderiliyor...' : 'Sıfırlama Bağlantısı Gönder'}
            </button>
          </form>
        )}

        <p className="auth-footer">
          <Link to="/login" className="icon-inline-link">
            <ArrowLeft size={16} aria-hidden />
            Giriş sayfasına dön
          </Link>
        </p>
      </div>
    </div>
  );
}
